import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { EntityType } from 'models/entity-permission.model';
import { EntityPermissionUsers } from 'models/user.model';

import API from '../../services/api';

import userKeys from './_queryKeys';

const getUsersWithEntityPermission = async (
    entityType: EntityType,
    entityId: string,
) => {
    const { data } = await API.getUsersWithEntityPermissions(
        entityType,
        entityId,
    );

    return data;
};

export default function useGetUsersWithEntityPermission(
    entityType: EntityType,
    entityId: string,
) {
    return useQuery<EntityPermissionUsers[], BaseError>({
        queryKey: userKeys.usersWithEntityPermission(entityType, entityId),
        queryFn: () => getUsersWithEntityPermission(entityType, entityId),
    });
}
